<div class="permissions">
  <div class="permission-list">
    <div class="tools">
      <div class="add">
        <sui-button
          variant="primary"
          [leadingIcon]="['fas', 'user-plus']"
          (click)="addPrincipals()"
        >
          {{ "object-permissions.button.add-principals" | translate }}
        </sui-button>
      </div>
    </div>

    <div class="permission-list-items">
      <form [formGroup]="formGroup">
        <table>
          <thead>
            <tr class="header">
              <!-- Add table headers if needed -->
            </tr>
          </thead>

          <tbody>
            @for (principal of principals; track principal) {
              <tr class="principal-permission">
                <td class="principal">
                  <div class="avatar">
                    <img
                      [src]="principal.image_url"
                      alt="Principal avatar"
                      appFallbackImage
                    />
                  </div>
                  <div class="principal-meta">
                    <div class="name">{{ principal.name }}</div>
                    <div class="email">{{ principal.email }}</div>
                  </div>
                </td>
                <td class="permission-role">
                  <div
                    [suiTooltip]="
                      'principal-info.tooltip.the-effective-permissions-are-inhertied-from-principals-role'
                        | translate
                    "
                    [suiTooltipDisabled]="
                      !(principal.is_owner || principal.is_business_admin)
                    "
                  >
                    <sui-select
                      [formControlName]="
                        'permission[' +
                        principal.object_class_id +
                        '][' +
                        principal.id +
                        ']'
                      "
                    >
                      @for (role of permissionRoleList; track role) {
                        <sui-select-option
                          [value]="role.id"
                          [label]="role.value"
                          [disabled]="
                            role?.id === NomObjectPermission.OWNER ||
                            role?.id === NomObjectPermission.ADMIN
                          "
                          >{{ role.value }}</sui-select-option
                        >
                      }
                    </sui-select>
                  </div>
                </td>
                <td>
                  @if (
                    principal?.permission_role_id !==
                      NomObjectPermission.OWNER &&
                    principal?.permission_role_id !== NomObjectPermission.ADMIN
                  ) {
                    <sui-button
                      size="sm"
                      variant="danger"
                      [leadingIcon]="['fas', 'circle-minus']"
                      [iconOnly]="true"
                      [ariaLabel]="
                        'principal-info.tooltip.revoke-principals-permissions'
                          | translate
                      "
                      [suiTooltip]="
                        'principal-info.tooltip.revoke-principals-permissions'
                          | translate
                      "
                      (click)="removePrincipal(principal)"
                    ></sui-button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </form>
    </div>
  </div>
</div>
